import * as React from 'react';
import FocusMatch from "../../containers/FocusMatch"
import StatisticsVideoArea from "./Components/StatisticsVideoArea"

// standaloneLayout
const StandaloneLayout = ( props: { focusmatchid: number }) => {
    const inner = (<div>
        <div className="sr-grid sr-row-sr-align-center guiHeader">
            <div className="sr-cell sr-xs-1-5 sr-show-up-to-m">
                <div className="sr-content">
                    <div></div>
                </div>
            </div>
        </div>
        <div className="sr-grid guiContent">
            <div className="sr-cell videoWrapper">
                <div className="sr-content sr-align-center">
                    <div className="videoContent sr-content">
                        <StatisticsVideoArea showPlayerProfiles={true} />
                    </div>
                </div>
            </div>
        </div>
    </div>)
    // we want to have this layout with and without focusmatchid support
    if(props.focusmatchid) {
        return (
            <div className="defaultGuiWrapper standalonelayout">
                <FocusMatch>
                    {inner}
                </FocusMatch>
            </div>
        )
    }else {
        return (
            <div className="defaultGuiWrapper standalonelayout">
                {inner}
            </div>
        )
    }
}

export default StandaloneLayout;
